import { CommonUtilities } from "../../commonUtils";
import Pagination from 'components/Common/newPagination';
import React, { Suspense, useState, useEffect } from "react";
import contractServices from "./contractServices";
import { Filter } from "filter";

export default function ContractIndicatorDetail(contractDetails: any) {

    let [passParm, SetpassParm] = useState<any>([])
    let [indicatorDetailValue, SetIndicatorDetailValue] = useState<any>([])

    useEffect(() => {
        //search();

        console.log("passParm")
        console.log(passParm)
        if (passParm.length == 0 && passParm?.contract != contractDetails?.paramDetail?.contract && passParm?.period?.periodDesc != contractDetails?.paramDetail?.contract) {
            apiCall()
            passParm = contractDetails?.paramDetail
            SetpassParm(passParm)
        }
    }, [contractDetails]);

    const apiCall = () => {
        if (contractDetails?.paramDetail?.contract && contractDetails?.paramDetail?.period?.periodDesc) {
            var payload = {
                contractCode: contractDetails?.paramDetail?.contract,
                periodNum: Filter.NumToDate(contractDetails?.paramDetail?.period?.periodDesc),
                type: "contractTotalBal"
            }
            contractServices.genericAPIListing(payload).then((respond: any) => {
                indicatorDetailValue = CommonUtilities.relativeDataRemapping(respond.data, respond.headers.original)
                SetIndicatorDetailValue(indicatorDetailValue)
            })
        }
    }

    const sumValue = (obj: any, fileName: any) => {

        var totalValue = 0;
        for (var i = 0; i < obj.length; i++) {
            totalValue = totalValue + obj[i][fileName]
        }

        return totalValue;
    }

    return (<>
        <div className="ws-12 borderRounded box pm">
            <div className="ws-12 borderSolidBlue borderRounded pm">

                <div className="w-14">
                    <div className="ws-12 pull-left mb">
                        <label className="ws-12 text-left text-bold text-center mt" >Gross</label>
                        {
                            indicatorDetailValue?.map((values: any) => {
                                return (
                                    <div className="ws-12 mbs pb pt">
                                        <span className="pull-right pr">{values.gross.toFixed(2)}</span>
                                    </div>
                                )
                            })
                        }

                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />
                        <div className="ws-12 mbs pbs">
                            <span className="pull-right pr">{sumValue(indicatorDetailValue, "gross").toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                <div className="w-14">
                    <div className="ws-12 pull-left mb">
                        <label className="ws-12 text-left text-bold text-center mt" >Res Held</label>
                        {
                            indicatorDetailValue?.map((values: any) => {
                                return (
                                    <div className="ws-12 mbs pb pt">
                                        <span className="pull-right pr">{values.totalReserveHeld.toFixed(2)}</span>
                                    </div>
                                )
                            })
                        }

                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />
                        <div className="ws-12 mbs pbs">
                            <span className="pull-right pr">{sumValue(indicatorDetailValue, "totalReserveHeld").toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                <div className="w-14">
                    <div className="ws-12 pull-left mb">
                        <label className="ws-12 text-left text-bold text-center mt" >Res Rel</label>

                        {
                            indicatorDetailValue?.map((values: any) => {
                                return (
                                    <div className="ws-12 mbs pb pt">
                                        <span className="pull-right pr">{values.totalReserveRelease.toFixed(2)}</span>
                                    </div>
                                )
                            })
                        }

                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />
                        <div className="ws-12 mbs pbs">
                            <span className="pull-right pr">{sumValue(indicatorDetailValue, "totalReserveRelease").toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                <div className="w-14">
                    <div className="ws-12 pull-left mb">
                        <label className="ws-12 text-left text-bold text-center mt" >Earnings</label>
                        {
                            indicatorDetailValue?.map((values: any) => {
                                return (
                                    <div className="ws-12 mbs pb pt">
                                        <span className="pull-right pr">{values.totalEarnings.toFixed(2)}</span>
                                    </div>
                                )
                            })
                        }

                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />
                        <div className="ws-12 mbs pbs">
                            <span className="pull-right pr">{sumValue(indicatorDetailValue, "totalEarnings").toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                <div className="w-14">
                    <div className="ws-12 pull-left mb">
                        <label className="ws-12 text-left text-bold text-center mt" >Recoupables</label>
                        {
                            indicatorDetailValue?.map((values: any) => {
                                return (
                                    <div className="ws-12 mbs pb pt">
                                        <span className="pull-right pr">{values.gross.toFixed(2)}</span>
                                    </div>
                                )
                            })
                        }

                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />
                        <div className="ws-12 mbs pbs">
                            <span className="pull-right pr">{sumValue(indicatorDetailValue, "gross").toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                <div className="w-14">
                    <div className="ws-12 pull-left mb">
                        <label className="ws-12 text-left text-bold text-center mt" >Adjustments</label>
                        {
                            indicatorDetailValue?.map((values: any) => {
                                return (
                                    <div className="ws-12 mbs pb pt">
                                        <span className="pull-right pr">{values.totalAdjustments.toFixed(2)}</span>
                                    </div>
                                )
                            })
                        }

                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />
                        <div className="ws-12 mbs pbs">
                            <span className="pull-right pr">{sumValue(indicatorDetailValue, "totalAdjustments").toFixed(2)}</span>
                        </div>
                    </div>
                </div>

                <div className="w-14">
                    <div className="ws-12 pull-left mb">
                        <label className="ws-12 text-left text-bold text-center mt" >Total Balance</label>
                        {
                            indicatorDetailValue?.map((values: any, index: any) => {
                                return (
                                    <div className="ws-12 mbs pb pt">
                                        <span className="pull-right pr text-bold">Q{index + 1}</span>
                                        <span className="pull-right prxl">{values.openingBalance.toFixed(2)}</span>
                                    </div>
                                )
                            })
                        }

                        <hr className="ws-12" style={{ border: "solid #8DCAE8 1px" }} />

                        <div className="ws-12 mbs pbs">
                            <span className="pull-right prxl mrxl">{sumValue(indicatorDetailValue, "openingBalance").toFixed(2)}</span>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </>)

}